import type { IBaseViewModel, IMeasurementViewModel } from '@/engine/app/interfaces';
import {
  createCustomSplineMeasurementAlgorithmBuilder,
  createSplineAlgorithmBuilder
} from '@/engine/PlanningAlgorithm/CustomMeasurementsAlgorithmBuilders';
import type { IIndicationAdder, IIndicationVMAdder } from '../interfaces';
import * as DT from '@/engine/PlanningAlgorithm/DataTypes';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';

export class SplineIndicationAdder implements IIndicationAdder<DT.Polyline> {
  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _indicationsVMAdder: IIndicationVMAdder;

  public constructor(planningAlgorithm: PlanningAlgorithm, indicationVMAdder: IIndicationVMAdder) {
    this._planningAlgorithm = planningAlgorithm;
    this._indicationsVMAdder = indicationVMAdder;
  }

  public async addIndication(splineModel: DT.Polyline, viewModel: IBaseViewModel): Promise<void> {
    const ptsDescriptor = viewModel.descriptor + '.pts';

    await this._planningAlgorithm.extendAlgorithmAsync(createSplineAlgorithmBuilder(ptsDescriptor), ptsDescriptor);

    await this._planningAlgorithm.setValueAsync(
      ptsDescriptor,
      new DT.Polyline({
        points: splineModel.value.points,
        isClosed: splineModel.value.isClosed
      })
    );

    await this._planningAlgorithm.extendAlgorithmAsync(
      createCustomSplineMeasurementAlgorithmBuilder(ptsDescriptor, viewModel.descriptor),
      viewModel.descriptor
    );
    this._indicationsVMAdder.addMeasurementViewModelToViews(viewModel as IMeasurementViewModel);
  }
}
